<template>
  <span v-if="badge" :class="['user-badge', 'user-badge--' + size]" :title="'徽章：' + badge.name">
    <span class="user-badge__icon">{{ badge.icon }}</span>
    <span v-if="showName" class="user-badge__name">{{ badge.name }}</span>
  </span>
</template>

<script>
import { resolveUserBadge, resolveBadgeByPoints } from '@/utils/badge'

// 用户名旁的徽章标签：支持传用户对象（含 points/徽章字段）或直接传积分
export default {
  name: 'UserBadge',
  props: {
    user: { type: Object, default: null },
    points: { type: [Number, String], default: undefined },
    // false 时只展示图标，适合昵称较长或空间紧凑的场景
    showName: { type: Boolean, default: true },
    // small / medium / large
    size: { type: String, default: 'small' }
  },
  computed: {
    badge() {
      if (this.user) {
        return resolveUserBadge(this.user)
      }
      if (this.points !== undefined && this.points !== null) {
        return resolveBadgeByPoints(this.points)
      }
      return null
    }
  }
}
</script>

<style scoped>
.user-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 6px;
  padding: 1px 8px 1px 5px;
  border-radius: 10px;
  background: rgba(138, 109, 59, 0.1);
  border: 1px solid rgba(138, 109, 59, 0.25);
  vertical-align: middle;
  white-space: nowrap;
  line-height: 1.4;
}

.user-badge__icon {
  font-size: 13px;
  line-height: 1;
}

.user-badge__name {
  font-size: 12px;
  color: var(--accent, #8a6d3b);
}

.user-badge--medium .user-badge__icon {
  font-size: 15px;
}

.user-badge--medium .user-badge__name {
  font-size: 13px;
}

.user-badge--large {
  padding: 3px 12px 3px 8px;
  border-radius: 14px;
}

.user-badge--large .user-badge__icon {
  font-size: 18px;
}

.user-badge--large .user-badge__name {
  font-size: 14px;
}
</style>
